import { useState } from 'react';
import { PersonJobType } from '@api';
import { getAllJobs } from './helpers';

type UseCheckedJobsReturnType = {
  checkedJobIds: string[];
  areAllJobIdsChecked: boolean;
  toggleAllJobIds: () => void;
  onCheckJobId: (jobId: string, isChecked: boolean) => void;
};

export const useCheckedJobs = (
  unconfirmedShows: PersonJobType[]
): UseCheckedJobsReturnType => {
  const [checkedJobIds, setCheckedJobIds] = useState<string[]>([]);

  const allJobs = getAllJobs(unconfirmedShows);

  const areAllJobIdsChecked = checkedJobIds.length === allJobs.length;

  const onCheckJobId = (jobId: string, isChecked: boolean): void => {
    setCheckedJobIds((prev) =>
      isChecked ? [...prev, jobId] : prev.filter((id) => id !== jobId)
    );
  };

  const toggleAllJobIds = (): void => {
    if (areAllJobIdsChecked) {
      setCheckedJobIds([]);
    } else {
      setCheckedJobIds(allJobs);
    }
  };

  return {
    checkedJobIds,
    areAllJobIdsChecked,
    toggleAllJobIds,
    onCheckJobId,
  };
};
